import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import { formatEntNumber } from '@/utils/approval/entExpense';
import UsageCell from './UsageCell';

type BudgetSummaryTableProps = {
  budgetItem: ReactNode;
  budgetYear: ReactNode;
  total: number;
  remaining: number;
  usageRate: number;
  /** 작성 화면 — 예산 항목·연도 칸이 셀렉트 */
  editable?: boolean;
};

/** 213 사용 예산 요약 — 작성·조회 공용 */
const BudgetSummaryTable = ({
  budgetItem,
  budgetYear,
  total,
  remaining,
  usageRate,
  editable = false,
}: BudgetSummaryTableProps) => {
  const { t } = useTranslation();
  const selectCellStyle = editable ? { padding: 0 } : undefined;
  return (
    <ApprovalFormTable className="ent-budget-table">
      <colgroup>
        <col style={{ width: 320 }} />
        <col style={{ width: 100 }} />
        <col style={{ width: 140 }} />
        <col style={{ width: 140 }} />
        <col style={{ width: 140 }} />
      </colgroup>
      <thead>
        <tr>
          <th>{t('예산 항목')}</th>
          <th>{t('연도')}</th>
          <th className="align-right">{t('전체 예산')}</th>
          <th className="align-right">{t('잔여 예산')}</th>
          <th>{t('소진율')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={selectCellStyle}>{budgetItem}</td>
          <td style={selectCellStyle}>{budgetYear}</td>
          <td className="align-right">{formatEntNumber(total)}</td>
          <td className="align-right">{formatEntNumber(remaining)}</td>
          <td>
            <UsageCell rate={usageRate} />
          </td>
        </tr>
      </tbody>
    </ApprovalFormTable>
  );
};

export default BudgetSummaryTable;
